import React from 'react'
import ShiftSchedule from './DemoGraph'

function DemoGraphIndex() {
    return (
        <div className='card'>
            <div className='card-header'>
                <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Shift Details</h1>
            </div>
            <div className='card-body'>
                <ShiftSchedule />
            </div>
        </div>
    )
}

export default DemoGraphIndex